import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d4d73c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Glossary__Inner" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Glossary__End" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlossaryHeader = _resolveComponent("GlossaryHeader")!
  const _component_GlossaryDetail = _resolveComponent("GlossaryDetail")!
  const _component_GlossarySection = _resolveComponent("GlossarySection")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(["Glossary footer-white-after", _ctx.isDetailOpened ? 'has-detail' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_GlossaryHeader, { onGoToLetter: _ctx.goToLetter }, null, 8, ["onGoToLetter"]),
      _createVNode(_component_GlossaryDetail, {
        glossary: _ctx.glossary,
        selectedDefinition: _ctx.selectedDefinition
      }, null, 8, ["glossary", "selectedDefinition"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createBlock(_component_GlossarySection, {
          key: 'glossary-section-'+item.letter+'_'+_ctx.glossary.lang,
          ref_for: true,
          ref: "section",
          item: item,
          "data-letter": item.letter,
          onOnReachChange: _ctx.onReachChange
        }, null, 8, ["item", "data-letter", "onOnReachChange"]))
      }), 128)),
      _hoisted_2
    ])
  ], 2))
}